import moment from "moment";
import { isItTimePickerMaxTime } from "../utils/time-picker-builder";
import BaseViewController from "./base-view-controller";
import { CALENDAR_OPTIONS_FIELD, WCAG_ADOPTED_TEXT } from "../utils/constants";

class ConsultationScheduleViewController extends BaseViewController {
  handleSelectChange(values) {
    const newValues = this.prepareSubmit({ ...this.appData.values, ...values });
    super.handleSelectChange(newValues);
  }

  addWcagParam = param =>
    param.split("|").includes(WCAG_ADOPTED_TEXT)
      ? param
      : `${param}|${WCAG_ADOPTED_TEXT}`;

  // This handler cover the shorten RAV flow
  // two screens (select communication method and consultation schedule) combine in one
  handleButtonClick = (
    name,
    text,
    action,
    replaceHistory = 0,
    initialScreen,
    eventStates
  ) => {
    const communicationActions = ["videoSpacer", "phoneSpacer"];
    if (communicationActions.includes(name) && eventStates) {
      const newValues = super.prepareSubmit({ ...this.appData.values });
      super.handleValuesChange(newValues);
      this.appData.updateStates(eventStates);
    } else {
      super.handleButtonClick(
        name,
        text,
        action,
        replaceHistory,
        initialScreen,
        eventStates
      );
    }
  };

  preprocessScreenData = () =>
    this.screen?.fields?.forEach(field => {
      if (field.name === "instructions") {
        field.params = this.addWcagParam(field.params);
      }
    });

  handleValuesChange(values) {
    const newValues = this.prepareSubmit({ ...this.appData.values, ...values });
    super.handleValuesChange(newValues);
  }

  onDemandDisabledChecker() {
    return (
      ["ConsultationOption", "ConsultationSchedulePhone"].includes(
        this.screen.name
      ) &&
      this.screen.fields &&
      this.screen.fields.findIndex(
        field => field.type === CALENDAR_OPTIONS_FIELD.type
      ) >= 0
    );
  }

  prepareSubmit(values) {
    const {
      __mode = "OND",
      __hour = "0",
      __ampm = "am",
      time_zone,
      request_date
    } = values;

    const __minute = values.__minute
      ? isItTimePickerMaxTime(values)
        ? "00"
        : values.__minute
      : "00";

    const onDemandDisabled = this.onDemandDisabledChecker();

    if (__mode !== "OND" || onDemandDisabled) {
      const requestDate = onDemandDisabled ? moment(request_date) : moment();

      if (time_zone) {
        requestDate.tz(time_zone);
      }

      if (!onDemandDisabled) {
        const hour = parseInt(__hour, 10);
        const minute = parseInt(__minute, 10);

        requestDate.hour(__ampm === "am" || hour === 12 ? hour : hour + 12);
        requestDate.minute(minute);
        requestDate.second(0);
      }

      if (__mode === "SCH+1") {
        requestDate.add(1, "day");
      }

      return {
        ...values,
        request_dt: requestDate.format(),
        request_date: requestDate.format(),
        mode: "SCH"
      };
    } else {
      return {
        ...values,
        request_dt: "ASAP",
        request_date: "ASAP",
        mode: "OND"
      };
    }
  }
}

export default ConsultationScheduleViewController;
